<template>
  <div class="form-group row">
    <form-label
      for-i-d="edit_audiencerule_name"
      :is-required="true"
      >{{ capitalize($t('names.daypart', { n: 1 })) }}
    </form-label>
    <div class="col-sm-8">
      <div class="toggle single">
        <toggle-button
          :value="isCustomDaypart"
          :sync="true"
          @change="toggleCustomDaypart()" />
        <span>{{ $t('actions.customizeDaypart') }}</span>
      </div>
      <daypart-editor
        v-if="isCustomDaypart"
        :is-compact="true"
        :daypart="audienceRule.daypart"
        @changed="handleDaypartChange" />
    </div>
  </div>
</template>
<script setup lang="ts">
  import { capitalize, computed } from 'vue';
  import { useStore } from 'vuex';

  import { DaypartEditor, FormLabel } from '@/common/components/controls';
  import ToggleButton from '@/common/components/controls/ToggleButton.vue';
  import AudienceRule from '@/common/models/audience/AudienceRule';
  import { FullDaypart } from '@/globals';

  // Setup
  const store = useStore();
  const props = defineProps<{
    audienceRule: AudienceRule;
  }>();

  // Computed
  const isCustomDaypart = computed({
    get() {
      return props.audienceRule.isCustomDaypart;
    },
    set(value) {
      if (!value) {
        // eslint-disable-next-line vue/no-mutating-props
        props.audienceRule.daypart = FullDaypart;
      }
      store.dispatch('updateAudienceRuleIsCustomDaypart', {
        audienceRule: props.audienceRule,
        value,
      });
    },
  });

  // Methods
  function toggleCustomDaypart() {
    isCustomDaypart.value = !isCustomDaypart.value;
  }

  function handleDaypartChange(daypart) {
    store.dispatch('updateAudienceRuleDaypart', {
      audienceRule: props.audienceRule,
      value: daypart,
    });
  }
</script>
